import React, { useState } from "react";
import Modal from "react-modal";
import { useStateValue } from "../../StateProvider";
import { getDefaultName, getDefaultValue } from "../../utils";
import { resolveMediaUrl } from "../../utils/Network";
import { KT_COURSE_PARTICIPATION_CHANGED } from "../../utils/contestParticipationEvents";
import { ContestHttpService } from "../../utils/http/contest_http_service";
import parse from 'html-react-parser'

export default function ModalContestSuggestion({isOpen = false , course, setIsOpen }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const closeModal = () => {
    if (loading) return;
    setIsOpen(false);
    setError("");
  };

  const participate = () => {
    if (loading || !course?.id) return;
    setLoading(true);
    setError("");
    ContestHttpService.participate({ course: course.id })
      .then((data) => {
        if (data?.error) {
          throw new Error(translate("You already participated in this competition"));
        }
        if (data?.Error) {
          throw new Error(translate("You cannot participate in this course again"));
        }
        window.dispatchEvent(
          new CustomEvent(KT_COURSE_PARTICIPATION_CHANGED, {
            detail: { courseId: course.id },
          })
        );
        setIsOpen(false);
      })
      .catch((err) => {
        setError(err?.message || translate("Unable to participate. Please try again."));
      })
      .finally(() => setLoading(false));
  };

  
  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    var translate = translations.find((x) => x.key == str);

    if (translate) return getDefaultValue(translate);
    else return "#" + str;
  };

  return (
    <Modal
      closeTimeoutMS={500}
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={closeModal}
      className="Modal"
      overlayClassName="Overlay"
    >
      <div className="modal-content">
        <div className="modal-body lan-text-right">
          <div className="text-color-primary">
              <div className="mb-3 lan-rtl">
                <img src={course && course.image ? resolveMediaUrl(course.image) : course && course.image} className="full-width" alt="" />
                <h3 className="mt-3">{course && getDefaultName(course.names)}</h3>
                {parse(translate('now you can participate in a contest'))}
              </div>
              {error && <div className="alert alert-danger mb-3" role="alert">{error}</div>}
              <button
                className="btn btn-primary width-200 pull-right rtl-pull-left"
                type="button"
                onClick={participate}
                disabled={loading || !course?.id}
              >
                {loading && <i className="fas fa-spinner fa-spin mr-2" aria-hidden="true" />}
                {loading ? translate('Please wait...') : translate('Participate')}
              </button>
              <button onClick={closeModal} disabled={loading} className="btn width-200 pull-right rtl-pull-left" type="button" >
                {translate('No')}
              </button> &nbsp;&nbsp;
              
          </div>
        </div>
        
      </div>
    </Modal>
  );
}
